import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imPasswordReminder', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/auth/password_reminder/password_reminder.html'),
        controller: 'PasswordReminderController',
        controllerAs: 'PasswordReminderCtrl',
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/password_reminder/password_remidner.component.ts